var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.ready
      ? _c(
          "div",
          { staticClass: "VirtualContractForReportWidget__Component" },
          [
            _vm._l(_vm.contracts, function(contract) {
              return _c(
                "div",
                {
                  key: contract.Id,
                  staticClass: "VirtualContractForReportWidget__Component__Item"
                },
                [
                  _c("label", [
                    _vm._v(" שוכר: "),
                    _c(
                      "a",
                      { attrs: { href: "/clients/" + contract.Profile.Id } },
                      [_c("span", [_vm._v(_vm._s(contract.Profile.Name))])]
                    )
                  ]),
                  _c("label", [
                    _vm._v(" ח.פ: "),
                    _c("span", [_vm._v(_vm._s(contract.Profile.IdNumber))])
                  ]),
                  contract.ContractOwner
                    ? _c("label", [
                        _vm._v(" חברת ליסינג: "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "/clients/" + contract.ContractOwner.Id
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(contract.ContractOwner.Name))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "label",
                    [
                      _vm._v(" מתאריך: "),
                      _c("FieldDateHourInline", {
                        attrs: { value: contract.StartDate }
                      })
                    ],
                    1
                  ),
                  _c(
                    "label",
                    [
                      _vm._v(" עד תאריך: "),
                      _c("FieldDateHourInline", {
                        attrs: { value: contract.EndDate }
                      })
                    ],
                    1
                  ),
                  _c("label", [
                    _vm._v(" הצהרת חוכר: "),
                    _c("span", [
                      _vm._v(_vm._s(contract.HasTransferHtml ? "כן" : "לא"))
                    ])
                  ]),
                  _c("label", [
                    _vm._v(" קיים טופס איסוף השכרה: "),
                    _c("span", [
                      _vm._v(
                        _vm._s(contract.HasRentalPickUpFormHtml ? "כן" : "לא")
                      )
                    ])
                  ]),
                  _c("label", [
                    _vm._v(" קיים טופס החזרת השכרה: "),
                    _c("span", [
                      _vm._v(
                        _vm._s(contract.HasRentalReturnFormHtml ? "כן" : "לא")
                      )
                    ])
                  ]),
                  _c("label", [
                    _vm._v(" קיים רישיון נהיגה: "),
                    _c("span", [
                      _vm._v(
                        _vm._s(contract.HasDriversLicenseHtml ? "כן" : "לא")
                      )
                    ])
                  ]),
                  _c(
                    "label",
                    [
                      _vm._v(" תאריך עדכון: "),
                      _c("FieldDateHourInline", {
                        attrs: { value: contract.UpdateDate }
                      })
                    ],
                    1
                  ),
                  _c("label", [
                    _vm._v(' עודכן ע"י: '),
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            contract.UpdatingUserName
                              ? contract.UpdatingUserName
                              : "-"
                          ) +
                          " "
                      )
                    ])
                  ]),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "VirtualContract",
                          params: { id: contract.Id }
                        }
                      }
                    },
                    [_c("span", { staticClass: "preview" }, [_vm._v("הצג")])]
                  )
                ],
                1
              )
            }),
            !_vm.contracts.length
              ? _c("div", [_vm._v("לא קיים חוזה נקודתי")])
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }